import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { Result } from "src/app/models/ResultModel";
import { Country } from "src/app/models/Country";
import { Port } from "src/app/models/Port";

@Injectable({
    providedIn: 'root'
})
export class CommonService {
    baseurl = `${environment.apiUrl}api/common`;

    constructor(private http: HttpClient) {

    }

    GetSourceCountries(): Observable<Result<Country[]>> {
        return this.http.get<Result<Country[]>>(`${this.baseurl}/GetSourceCountryList`);
    }

    GetSourceCountryPorts(countryId: number): Observable<Result<Port[]>> {
        return this.http.get<Result<Port[]>>(`${this.baseurl}/GetSourcePortList?toCountryId=${countryId}`);
    }

    GetDestinationCountry(countryId: number, portIds: number[]): Observable<Result<Country[]>> {
        let url = this.baseurl +  '/GetDestinationCountryList' + '?toCountryId=' + countryId;
        portIds.forEach(x => {
          url = url + "&toPortIds=" + x;
        });
        return this.http.get<Result<Country[]>>(url);
    }

    GetDestinationCountryPorts(countryId: number, portsId: number[]): Observable<Result<Port[]>> {
        let url = this.baseurl +  '/GetDestinationPortList' + '?fromCountryId=' + countryId;
        portsId.forEach(x => {
          url = url + "&toPortIds=" + x;
        });
        return this.http.get<Result<Port[]>>(url);
    }

}